import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Apple, Smartphone } from "lucide-react";
import Footer from "@/components/Footer";

const APP_STORE_URL = "https://apps.apple.com/it/app/nutrinori/id6772290498";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=app.emergent.quicklaunch151cf78ab11&hl=fr";

const PublicLink = () => {
  const { slug } = useParams();
  const [showLanding, setShowLanding] = useState(false);

  const detectOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    }
    if (/android/i.test(userAgent)) {
      return 'android';
    }
    return 'desktop';
  };

  useEffect(() => {
    // Si un slug est présent, rediriger vers la route API backend pour smart link
    if (slug) {
      window.location.href = '/api/r/' + slug;
      return;
    }

    // Si pas de slug (page d'accueil), détection OS et redirection automatique
    const os = detectOS();
    
    if (os === 'ios') {
      // Redirection automatique vers App Store
      window.location.href = APP_STORE_URL;
    } else if (os === 'android') {
      // Redirection automatique vers Google Play
      window.location.href = GOOGLE_PLAY_URL;
    } else {
      // Desktop - afficher la landing page
      setShowLanding(true);
    }
  }, [slug]);

  const handleDownload = (store) => {
    if (store === 'ios') {
      window.open(APP_STORE_URL, '_blank');
    } else {
      window.open(GOOGLE_PLAY_URL, '_blank');
    }
  };

  // Pendant la détection/redirection, ne rien afficher
  if (!showLanding) {
    return null;
  }

  // Landing page pour desktop uniquement
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#F6F1E9' }}>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-4xl w-full">
          <div className="text-center mb-12">
            <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ color: '#0A120D' }} data-testid="landing-title">
              Téléchargez NutriNori
            </h1>
            <p className="text-lg sm:text-xl" style={{ color: '#3A453F' }}>
              Votre application nutrition sur iOS et Android
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <button
              onClick={() => handleDownload('ios')}
              className="card hover:shadow-lg transition-all duration-150 cursor-pointer group"
              style={{ borderColor: 'rgba(61, 107, 74, 0.15)' }}
              data-testid="ios-download-button"
            >
              <div className="flex items-center justify-center mb-4">
                <Apple className="w-16 h-16" style={{ color: '#3D6B4A' }} />
              </div>
              <h2 className="text-2xl font-semibold mb-2 text-center" style={{ color: '#0A120D' }}>
                App Store
              </h2>
              <p className="text-center" style={{ color: '#6B756D' }}>
                Pour iPhone et iPad
              </p>
            </button>

            <button
              onClick={() => handleDownload('android')}
              className="card hover:shadow-lg transition-all duration-150 cursor-pointer group"
              style={{ borderColor: 'rgba(61, 107, 74, 0.15)' }}
              data-testid="android-download-button"
            >
              <div className="flex items-center justify-center mb-4">
                <Smartphone className="w-16 h-16" style={{ color: '#3D6B4A' }} />
              </div>
              <h2 className="text-2xl font-semibold mb-2 text-center" style={{ color: '#0A120D' }}>
                Google Play
              </h2>
              <p className="text-center" style={{ color: '#6B756D' }}>
                Pour Android
              </p>
            </button>
          </div>
        </div>
      </div>
      
      <Footer theme="light" />
    </div>
  );
};

export default PublicLink;
